import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import Table from "../../../Components/Table/Table";
import {
  SearchFilter,
  ActionButton,
  CalendarFilter2,
  ProDropFilter,
  FilterButtonWithModal,
  CalendarFilter3,
} from "../../../Components/Search/Search";
import Pagination from "../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { URL } from "../../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { TableActions } from "../../../Components/Misc/ActionsModVersion";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import { FilterButton } from "../../../Components/Search/Search";
import "./style.css";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import {
  FiChevronDown,
  FiDelete,
  FiEdit2,
  FiEdit3,
  FiEye,
  FiTrash,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import { FaHotel } from "react-icons/fa";
import {
  GetCostClasses,
  GetCostService,
  GetCostServices,
  setEditMode,
  viewCostService,
} from "../../../../../utils/redux/Finance/CostCenterSlice/CostCenterSlice";
import {
  ApproveRecommendation,
  CancelRecommendation,
  GetRecommendations,
} from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import {
  FormatStatus,
  getColorByStatus,
} from "../../../../../utils/functions/FormatStatus";
import { toast } from "react-toastify";

function Recommendations() {
  // Filter states
  const [optionOpen, setOptionOpen] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [date, setDate] = useState(null);
  const [bank, setBank] = useState(null);
  const [status, setStatus] = useState(null);

  const [search, setSearch] = useState("");
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [filter, setFilter] = useState(1);
  const [refetch, setRefetch] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  /** Data Fetching */
  let data = useSelector((state) => state?.companyFund?.Recommendations);

  useEffect(() => {
    dispatch(
      GetRecommendations({
        pageSize,
        pageNumber,
        AccountName: search,
        date,
        ApprovalStatus: filter,
      })
    );
  }, [
    pageNumber,
    pageSize,
    search,
    date,
    bank,
    status,
    endDate,
    startDate,
    dispatch,
    refetch,
  ]);

  // Action Button at the top of screen
  const actionButton = (
    <>
      <CTAButtons
        onClick={() => {
          dispatch(setEditMode(false));
          navigate("../RecommendInvestmentAmount");
        }}
      >
        Recommend for investment
      </CTAButtons>
    </>
  );

  let currentHeaders = [
    {
      title: "Date",
      key: "date",
    },
    {
      title: "Name",
      key: "name",
    },
    {
      title: "Available Balance",
      key: "available_balance",
    },
    {
      title: "Investible Amount",
      key: "investible_amount",
    },
    {
      title: "Status",
      key: "status",
    },
    {
      title: "Actions",
      key: null,
    },
  ];

  // Format for "More Options" buttons:
  let mockRowOptions = (item) => [
    {
      name: "Edit Recommendation",
      icon: <FiEdit2 color="#946300" />,
      action: () => {
        // Navigate to the edit page with the selected item's ID
        navigate(`../RecommendInvestmentAmount/${item.id}/edit`);
      },
    },
    {
      name: "Cancel Recommendation",
      icon: <FiTrash color="#E61B00" />,
      action: async () => {
        try {
          const res = await dispatch(CancelRecommendation(item.id)).then(
            (response) => {
              if (response.payload.successful === true) {
                toast.success(response.payload.statusMessage);
                setRefetch(!refetch);
              } else {
                toast.error(response.payload.statusMessage);
              }
            }
          );
          console.log({ res });
        } catch (error) {
          console.log(error);
        }
      },
    },
    {
      name: "Approve Recommendation",
      icon: <FiEye color="#1E40AF" />,
      action: async () => {
        try {
          const res = await dispatch(ApproveRecommendation(item.id)).then(
            (response) => {
              if (response.payload.successful === true) {
                // toast.success(response.payload.statusMessage);
                setRefetch(!refetch);
              } else {
                toast.error(response.payload.statusMessage);
              }
            }
          );
          console.log({ res });
        } catch (error) {
          console.log(error);
        }
      },
    },
  ];

  const filterBy = [
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Declined",
      filter: 11,
    },
  ];

  return (
    <RouteLayout title={"Finance"}>
      <PageStyle
        title={"Recommendations for Investment"}
        hasBack={false}
        action={[actionButton]}
        isMain={true}
      >
        <div className={`${DashboardStyle.dashboard_filter} relative`}>
          <SearchFilter text={setSearch} />
          <CalendarFilter2
            name={"Date Range"}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          />
          <div className="text-green-800 text-[12px]">
            <ProDropFilter
              filter={filter}
              setFilter={setFilter}
              name={"Approval Status"}
              filterBy={filterBy}
            />
          </div>
          <FilterButton
            onClick={() =>
              dispatch(
                GetRecommendations({
                  pageSize,
                  pageNumber,
                  search,
                  date,
                  ApprovalStatus: filter,
                })
              )
            }
          />
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                {currentHeaders.map((header, i) => (
                  <th
                    className={`!text-[#29382A] ${
                      header.title === "Actions" && "flex justify-end !pr-6"
                    }`}
                    key={i}
                  >
                    {header.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={data?.result}
                keys={currentHeaders.map((header) => header.key)}
                selectable={false}
                rowOptions={mockRowOptions}
              />
            </tbody>
          </Table>
        </div>

        <Pagination
          last_page={data?.totalPages}
          present_page={data?.currentPage}
          totalRows={data?.totalRows}
          pageSize={data?.pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        />
      </PageStyle>
    </RouteLayout>
  );
}

export default Recommendations;

function RequestTable({
  data,
  keys,
  selectable,
  HandleSelectedItems,
  selectedItems,
  rowOptions,
}) {
  const navigate = useNavigate();

  return (
    <>
      {data?.map((item) => (
        <tr key={item.id}>
          {selectable && (
            <td>
              <input
                type="checkbox"
                checked={selectedItems.includes(item.id)}
                onChange={(e) => HandleSelectedItems(item.id, e.target.checked)}
                style={{ height: "20px", width: "20px" }}
              />
            </td>
          )}

          <td>{FormatDateTime(item?.createdDate)}</td>
          <td>{item?.ftLedger?.accountName}</td>
          <td>{FormatCurrency(item?.availableBalance)}</td>
          <td>{FormatCurrency(item?.investibleAmount)}</td>
          <td>
            <span
              style={{
                color: getColorByStatus(item?.approvalStatus).color,
                backgroundColor: getColorByStatus(item?.approvalStatus)
                  .backgroundColor,
                padding: "4px", // Optional padding for better visual presentation
                borderRadius: "4px", // Optional rounded corners
              }}
            >
              {FormatStatus(item?.approvalStatus)}
            </span>
          </td>

          <td>
            <div className={`flex justify-end bg-transparent`}>
              <TableActions
                rowData={item}
                url={`/dashboard/finance/Company-Fund/RecommendInvestmentAmount/${item?.id}/view`}
              >
                {/* Pass item into mockRowOptions */}
                {item?.approvalStatus === 1 && rowOptions(item)}
              </TableActions>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}

function StatusText({ status }) {
  return (
    <td style={{ textAlign: "center" }}>
      <span
        className={`
          ${
            status === "Approved"
              ? "bg-green-100 text-green-700"
              : status === "Declined"
              ? "bg-red-100 text-red-700"
              : "bg-amber-200 text-[#946300]"
          }
        `}
        style={{
          textAlign: "center",
          padding: "0.3rem 0.4rem",
          borderRadius: "10px",
          fontSize: "0.875rem",
          fontWeight: "600",
        }}
      >
        {status}
      </span>
    </td>
  );
}
